export const dummyChartData = [
    { name: 'Instagram', uv: 53200000 },
    { name: 'Spotify', uv: 26300000 },
    { name: 'YouTube', uv: 14200000 },
    { name: 'TikTok', uv: 6300000 },
];

export const chartStats = {
    quantity_past_month: 170000000,  
    value_difference: 170000,      
};